<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Select } from '@client/components/select';
  import { Switch } from '@client/components/switch';

  export let route = {};
  export let businessCardOptions = [];
  export let groupOptions = [];
  export let onSignatureChange = () => {};
</script>

<div class="bizcard-route-form">
  <div class="section" aria-labelledby="type-label">
    <p id="type-label">
      {$format('label.SELECT_TYPE', {
        values: { type: $format('label.BUSINESS_CARD') }
      })}
      <Icon name="help-circle" id="tooltip-route-signature" />
      <Tooltip target="tooltip-route-signature" placement="top">
        {@html $format('label.TOOLTIP.ROUTE_BUSINESS_CARD')}
      </Tooltip>
    </p>
    <Select
      bind:items={businessCardOptions}
      on:change={onSignatureChange}
      value={route.blockname}
      placeholder={$format('label.PLACEHOLDER.SELECT_BUSINESS_CARD')}
      clearable={false}
      showChevron
    />
  </div>
  <div class="section" aria-labelledby="groups-label">
    <p id="groups-label">
      {$format('label.GROUPS')}
      <Icon name="help-circle" id="tooltip-route-groups" />
      <Tooltip target="tooltip-route-groups" placement="top">
        {$format('label.TOOLTIP.ROUTE_GROUPS')}
      </Tooltip>
    </p>
    <Select
      bind:items={groupOptions}
      bind:value={route.selectedGroups}
      placeholder={$format('label.PLACEHOLDER.SELECT_GROUP')}
      clearable={false}
      multiple
      showChevron
    />
  </div>
  <div class="section" aria-labelledby="status-label">
    <p id="status-label">
      {$format('label.ACTIVE')}
      <Icon name="help-circle" id="tooltip-route-status" />
      <Tooltip target="tooltip-route-status" placement="top">
        {$format('label.TOOLTIP.ROUTE_STATUS')}
      </Tooltip>
    </p>
    <Switch bind:checked={route.status} aria-labelledby="status-label" />
  </div>
</div>

<style lang="scss">
  .bizcard-route-form {
    .section {
      p {
        font-weight: var(--font-weight-medium);
        margin-bottom: var(--margin-base);
      }

      + .section {
        margin-top: var(--margin-large);
      }

      .empty {
        color: var(--color-gray-600);
        padding: var(--padding-xlarge);
        text-align: center;
      }
    }
  }
</style>
